import { jsx as n } from "react/jsx-runtime";
import { mediumScreenModalStyle as k } from "../../../../styles/shared/index.js";
import { Icon as f } from "../../../../components/Icon/index.js";
import { useQuillActiveFormat as p } from "../../hooks/useQuillActiveFormat/index.js";
import { ToolbarButton as h } from "../../styles.js";
import { LinkModal as x } from "../LinkModal/index.js";
import { Link as L } from "@pelando/fontawesome/icons";
import { useTranslation as T } from "../../../../hooks/useTranslation/index.js";
import { useModal as b } from "../../../../components/Modal/context.js";
function I({ quill: t, className: a }) {
  const { t: e } = T("common"), { showModal: c } = b(), d = p(t);
  return /* @__PURE__ */ n(
    h,
    {
      type: "button",
      onClick: () => {
        const { index: o, length: r } = (t == null ? void 0 : t.getSelection()) || { index: 0, length: 0 }, m = (t == null ? void 0 : t.getText(o, r).trim()) || "";
        c(
          /* @__PURE__ */ n(x, { onAddLink: ({ link: i, text: s }) => {
            if (m) {
              t == null || t.formatText(o || 0, r || 0, "link", i);
              return;
            }
            t == null || t.insertText(o || 0, s, "link", i);
          }, selectedText: m }),
          {
            style: k
          }
        );
      },
      "aria-pressed": !!d.link,
      title: e("link-button-title"),
      className: a,
      children: /* @__PURE__ */ n(f, { icon: L, "aria-label": e("link-button-title") })
    }
  );
}
export {
  I as LinkButton
};
